import React, { useState, useEffect } from 'react'
import List from './List'
import Alert from './Alert'
const getLocalStorage = () =>{
  let getList =localStorage.getItem('list');
  if(getList){
    return JSON.parse(getList); 
  }
  else{
    return [];
  }
}
function App() {
  const [name,setName]=useState('');
  const [list,setList]=useState(getLocalStorage());
  const[isEditing,setIsEditing]=useState(false);
  const[editID,setEditID]=useState(null);
  const[alert,setAlert]=useState({show:false,msg:'',type:''});
  const showAlert= (show=false,type='',msg='') =>{
    setAlert({show,type,msg});
    }
  const clearList = () =>{
    showAlert(true,'danger','empty list');
    setList([]);
  };  
  const removeItem = (id) =>{
    showAlert(true,'danger','item removed');
    setList(list.filter((item) => item.id !== id ));
  }
  const editItem = (id) =>{
  const specificItem = list.find((item) => item.id === id);
  setIsEditing(true);
  setEditID(id);
  setName(specificItem.title);
  }
  useEffect(() =>{
    localStorage.setItem('list',JSON.stringify(list));
  },[list]);
const handleEvent=(e) =>{
e.preventDefault();
if(!name){
showAlert(true,'danger','please enter value');
}
else if(name &&isEditing){

setList(list.map((item)=>{
if(item.id===editID){
  return {...item,title:name}
}
return item;
}));
showAlert(true,'success','item edited succesfully');
setName('');
setEditID(null);
setIsEditing(false);
}
else{
    showAlert(true,'success','item added to the list');
    const newItem={id: new Date().getTime().toString(),title:name};
    setList([...list,newItem]);
    setName('');
}
};
return (<section className='section-center'>
      <form className='grocery-form' onSubmit={handleEvent}>
          {alert.show && <Alert {...alert} removeAlert={showAlert} list={list}/>}
          <h3>Grocery List</h3>
          <div className='form-control'>
              <input type='text'className='grocery' placeholder='eg.eggs' value={name} onChange={(e)=>setName(e.target.value)}/>
              <button className='submit-btn' type='submit'>
                  {isEditing ? 'edit':'submit'}
              </button>
          </div>
      </form>
      {list.length>0 && <div className='grocery-container'>
        <List items={list} removeItem={removeItem} editItem={editItem}/>
        <button className='clear-btn' onClick={clearList}>clear items</button>
      </div>}
  </section>);
}

export default App
